import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const SUGGESTIONS = [
  "Show me where we're losing the most users",
  "What are the top 3 trends I should know?",
  "Which accounts need follow-up?",
  "Common objections from high-intent buyers",
];

interface QuickSuggestionPillsProps {
  onSuggestionClick: (suggestion: string) => void;
  className?: string;
}

export const QuickSuggestionPills: React.FC<QuickSuggestionPillsProps> = ({
  onSuggestionClick,
  className,
}) => {
  return (
    <div className={cn('relative', className)}>
      <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
        {SUGGESTIONS.map((suggestion, index) => (
          <Button
            key={index}
            variant="outline"
            size="sm"
            onClick={() => onSuggestionClick(suggestion)}
            className="shrink-0 rounded-full border border-[hsl(var(--input))] card-bg-light text-sm font-normal text-muted-foreground hover:text-heading hover:bg-accent whitespace-nowrap px-4 transition-colors"
          >
            {suggestion}
          </Button>
        ))}
      </div>
      {/* Right fade gradient - adapts to light/dark mode via CSS custom property */}
      <div className="absolute right-0 top-0 bottom-1 w-12 bg-gradient-to-l from-[hsl(var(--background))] to-transparent pointer-events-none" />
    </div>
  );
};
